import { UploadResult } from 'src/components/dropZoneUploader'
import { PostType } from 'src/hook/usePosts'

import { UsePostModalUploadProps } from './usePostModalUpload.types'

const usePostModalUpload = ({
  setPostType,
  setMedia,
  setCurrentMedia,
  setFileUploaded
}: UsePostModalUploadProps) => {
  const getPostType = (type: string) => {
    if (type?.startsWith('image/')) {
      return PostType.IMAGE
    }

    if (type?.startsWith('video/')) {
      return PostType.VIDEO
    }

    if (type?.startsWith('audio/')) {
      return PostType.AUDIO
    }

    return PostType.IMAGE
  }

  const onDropZoneSuccess = (files?: UploadResult[]) => {
    const fileObject = files?.[0]
    const url = fileObject?.blobUrl as string
    const mediaKey = fileObject?.mediaKey as string
    const dimension = fileObject?.file.dimensions || undefined
    const postType = getPostType(fileObject?.file?.type as string)

    setPostType(postType)
    fileObject && setFileUploaded(fileObject.file)
    setCurrentMedia(url)

    mediaKey &&
      setMedia({
        ...(dimension && {
          mediaWidth: dimension.width,
          mediaHeight: dimension.height
        }),
        mediaKey
      })
  }

  return {
    onDropZoneSuccess
  }
}

export default usePostModalUpload
